var React = require('react');

function Spotify (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.44 0 8 0ZM11.6807 11.56C11.5207 11.7993 11.2407 11.88 11 11.72C9.12 10.56 6.76 10.3193 3.95933 10.9593C3.68067 11.0407 3.44 10.84 3.36 10.6C3.28 10.3193 3.48 10.08 3.72 10C6.76 9.31933 9.4 9.6 11.48 10.88C11.76 11 11.7993 11.3193 11.6807 11.56ZM12.6407 9.36C12.44 9.64 12.08 9.76 11.7993 9.56C9.64 8.24 6.36 7.84 3.84 8.64C3.52067 8.72 3.16 8.56 3.08 8.24C3 7.92 3.16 7.55933 3.48 7.47933C6.4 6.6 10 7.04067 12.48 8.56C12.7207 8.68067 12.84 9.08 12.6407 9.36ZM12.7207 7.12C10.16 5.6 5.88 5.44 3.44 6.20067C3.04 6.32 2.64 6.08 2.52 5.72C2.4 5.31933 2.64 4.92 3 4.79933C5.84 3.95933 10.52 4.11933 13.4807 5.88C13.84 6.08 13.96 6.56 13.76 6.92C13.5607 7.20067 13.08 7.31933 12.7207 7.12Z","fill":"black"}));
}

Spotify.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = Spotify;

Spotify.default = Spotify;
